import baseReport from '../baseReport';
import Meses from '@/utils/dias';
import formatDataBR from '@/plugins/filters/formatDataBR';

const montarTableHeader = (periodos) => {
  let header1 = [];
  let header2 = [];
  for(const periodo of periodos) {
    header1.push(...[
      { text: periodo.dspravadi, alignment: 'center', style: 'tableHeader', colSpan: 2 },
      {},
    ]);
    header2.push(...[
      { text: 'Conceito Período', alignment: 'center', style: 'tableHeader' },
      { text: 'Qtde de Faltas', alignment: 'center', style: 'tableHeader' },
    ]);
  }

  return [
    [
      {
        margin: [0, 12, 0, 0],
        text: 'Alunos',
        alignment: 'center',
        style: 'tableHeader',
        rowSpan: 2,
      },
      ...header1,
      {
        margin: [0, 8, 0, 0],
        text: 'Conceito Final',
        alignment: 'center',
        style: 'tableHeader',
        rowSpan: 2,
      },
      {
        margin: [0, 8, 0, 0],
        text: 'Total Geral de Faltas',
        alignment: 'center',
        style: 'tableHeader',
        rowSpan: 2,
      },
    ],
    [
      {},
      ...header2,
      {},
      {},
    ],
  ];
};

const montarAssinatura = (professores) => {
  return [
    {
      columns: [
        { width: '*', text: '' },
        {
          width: 'auto',
          alignment: 'right',
          layout: 'noBorders',
          table: {
            body: [
                ...professores.map(key => ([{
                  alignment: 'center',
                  fontSize: 8,
                  margin: [15, 35, 15, 0],
                  text: [
                    '_____________________________________________\n',
                    'Assinatura do Professor/Educador\n',
                    `${key.nmfuncion}\n`,
                    `${key.cdpessoal}-${key.cdmatric}`
                  ],
                }])),
            ],
          },
        },
        { width: '*', text: '' },
      ],
    },
  ];
};

const registroConceitoAnaliticoReport = async ({ date, time, filtros, alunos, conceitos, professores, periodos, tipoDeEnsino, indicaanoletivoexcedeu = 'N', anoSubsequente }) => {
  const headerFooter = await baseReport({ date, time, title: 'Diário de Classe', subTitle: 'Registro de Conceito e Frequência' }, 'landscape');

  let nameProfessores = professores.reduce((total, key) => `${total}${key.nmfuncion.trim()}, `, '');
  nameProfessores = nameProfessores.substring(0, nameProfessores.length - 2);

  const AnoSubsquente = indicaanoletivoexcedeu === 'S' ? [ { text: '   Ano subsequente:   ', bold: true }, anoSubsequente ] :  []

  const filtrosFormated = [
    {
      text: filtros.nmescola,
      bold: true,
      fontSize: 12,
      alignment: 'center',
      margin: [0, 5, 0, 5],
    },
    {
      fontSize: 9,
      text: [
        { text: 'Professor/Educador:   ', bold: true },
        nameProfessores,
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: 'Ano letivo:  ', bold: true },
            filtros.aaletivo,
            ...AnoSubsquente
          ],
        },
        {
          alignment: 'right',
          text: [
            { text: 'Turma:   ', bold: true },
            filtros.turma,
          ],
        },
      ],
    },
    {
      fontSize: 9,
      columns: [
        {
          text: [
            { text: (filtros.aaletivo >=2020 && tipoDeEnsino === 'I') ? 'Campos de Experiência:   ' : 'Disciplina:   ', bold: true },
            filtros.disciplina,
          ],
        },
        {},
      ],
    },
  ];

  if (alunos.length <= 0) {
    return {
      ...headerFooter,
      ...filtrosFormated,
      content: [{
        text: 'Nenhum aluno com conceito encontrado.',
        fontSize: 10,
        alignment: 'center',
        margin: [0, 15, 0, 0],
        bold: true,
      }],
    };
  }

  const formatedAlunos = alunos.map(key => {
    let itens = [];
    for(const periodo in periodos) {
      let valorFalta = 0;
      const faltaPeriodo = key.faltas.find(f => f.cdpravadi == periodos[periodo].cdpravadi);
      if(faltaPeriodo) { valorFalta = faltaPeriodo.qnt; }

      itens.push(...[
        { fontSize: 8, text: key.totalPeriodos[periodo], alignment: 'center' },
        { fontSize: 8, text: valorFalta, alignment: 'center' },
      ]);
    }

    const totalFaltas = key.faltas.reduce((total, valor) => total + parseInt(valor.qnt), 0);

    return [
      {
        fontSize: 8,
        text: `${key.nmaluno}${(key.invalido==='PDI')? ' - ' + key.invalido :''}\nDt Enturmacao: ${formatDataBR(key.dtsitalun)}${(key.invalido!='PDI' && key.invalido != null)? ' ' + key.invalido :''} ${(key.invalido!='PDI' && key.invalido != null )? ' - ' + formatDataBR(key.dtafastam) : ''}`,
        //text: `${key.nmaluno}${(key.invalido)? ` - ${key.invalido}` : ''}`,
        fillColor: ((key.invalido)? '#FFDAB9' : ''),
      },
      ...itens,
      {
        fontSize: 8,
       // text: ((key.totalPeriodos.every(c => c !== '-'))? key.totalGeral: '-'),
             //Apenas para o ano letivo de 2020, para Educação Infantil (semestres - 13, 14), não
            //houve primeiro semestre devido a pandemia da COVID-19, então o conceito final será o mesmo
            //conceito do segundo semestre, não sendo necessário o if para imprimir "-" se não houver algum conceito
            //lançado em um dos semestres
       text: (key.aaletivo === 2020 && tipoDeEnsino === 'I')?
                                                            key.totalGeral
                                                            : ((key.totalPeriodos.every(c => c !== '-'))? key.totalGeral: '-') ,
        alignment: 'center',
        fillColor: '#D3D3D3',
        bold: true,
      },
      {
        fontSize: 8,
        text: totalFaltas,
        alignment: 'center',
        fillColor: '#D3D3D3',
        bold: true,
      },
    ];
  });

  let dataFormated = [
    {
      margin: [0, 15, 0, 3],
      table: {
        widths: [
          { width: '*' },
          ...periodos.reduce((total) => { total.push(...[{ width: 'auto' }, { width: 'auto' }]); return total; }, []),
          { width: 'auto' },
          { width: 'auto' },
        ],
        body: [
          ...montarTableHeader(periodos),
          ...formatedAlunos,
        ],
      },
    },
  ];

  return {
    ...headerFooter,
    content: [
      ...filtrosFormated,
      ...dataFormated,
      {
        margin: [0, 23, 0, 3],
        columns: [
          {
          },
          {
            width: '70%',
            alignment: 'right',
            table: {
              widths: ['30%', '70%'],
              body: [
                [
                  { text: 'Legenda',
                    colSpan: 2,
                    alignment: 'center',
                    bold: true,
                    fontSize: 8,
                    color: 'black',
                    fillColor: '#eeeeee', },
                  {},
                ],
                ...conceitos.map(key => ([
                  { text: key.valorconceito, fontSize: 8, alignment: 'center' },
                  { text: key.descricaoconceito, fontSize: 8, alignment: 'center' },
                ])),
              ],
            }
          },
        ],
      },
      ...montarAssinatura(professores),
    ],
    styles: {
      tableHeader: {
        bold: true,
        fontSize: 10,
        color: 'black',
        fillColor: '#eeeeee',
      },
    },
  };
};

export default registroConceitoAnaliticoReport;
